@if(service.viewDroplistItems.length){
<div class='devo-donors-views-part'>
	@if(service.selectedViewItem(); as selectedViewItem){
	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem' (selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true' sortBy='customSort' style='display:inline-block'>
	</droplist>
	<ng-container [ngSwitch]="selectedViewItem.uniqueId">
		<devo-donors-donors-view-part *ngSwitchCase="service.viewId.Donors"></devo-donors-donors-view-part>
		<devo-donors-contacts-view-part *ngSwitchCase="service.viewId.Contacts"></devo-donors-contacts-view-part>
		<devo-donors-gifts-view-part *ngSwitchCase="service.viewId.Gifts"></devo-donors-gifts-view-part>
	</ng-container>
	}
</div>
}